import React, { useState, useContext, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { CommonContext } from '../../../context';
import { AppUrl } from '../../../utils/config';
import { Card, CardContent, FormControl, Grid, IconButton, Input, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import commonApi from '../../../utils/api';
import { scrollToTop } from '../../common/scrollToTop';

const KycDetails = () => {
    const { user, setIsLoading, setOpenAlert, setAlertMessage, setSeverity, merchantDetails, rowData } = useContext(CommonContext);
    // const { rowData } = useContext(MerchantContext);

    const [formErrors, setFormErrors] = useState({});
    const [formDataTemp, setformDataTemp] = useState({
        adhar_card_no: '',
        adhar_card_file: null,
        pan_card_no: '',
        pan_card: null,
        gst_number: '',
        gst_file: null,
    });
    useEffect(() => {
        if (merchantDetails?.merchantKycDetails) {
            setformDataTemp(merchantDetails?.merchantKycDetails)
        }
    }, [merchantDetails]);

    const handleChange = (event) => {
        const { name } = event.target;
        const value = event.target.files ? event.target.files[0] : event.target.value;
        setformDataTemp((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const errors = {};
        // if (!formDataTemp?.adhar_card_no) {
        //     errors.adhar_card_no = 'Adhar number is required';
        // }
        // if (!formDataTemp?.pan_card_no) {
        //     errors.pan_card_no = 'Pan number is required';
        // }
        // if (!formDataTemp?.gst_number) {
        //     errors.gst_number = 'GST number is required';
        // }
        // if (!formDataTemp?.gst_file) {
        //     errors.gst_file = 'GST file is required';
        // }
        // if (!formDataTemp?.pan_card) {
        //     errors.pan_card = 'PAN Copy is required';
        // }
        // if (!formDataTemp?.adhar_card_file) {
        //     errors.adhar_card_file = 'Adhar copy is required';
        // }
        setFormErrors(errors);
        if (Object.keys(errors).length === 0) {
            setIsLoading(true);
            let formData = new FormData();
            formData.append('gst_number', formDataTemp.gst_number);
            formData.append('gst_file', formDataTemp.gst_file);
            formData.append('pan_card', formDataTemp.pan_card);
            formData.append('pan_card_no', formDataTemp.pan_card_no);
            formData.append('adhar_card_file', formDataTemp.adhar_card_file);
            formData.append('adhar_card_no', formDataTemp.adhar_card_no);
            if (user?.user_type === 'Merchant') {
                formData.append('merchant_id', user?.id);
            } else {
                formData.append('merchant_id', rowData?.id);
            }
            // axios({
            //     method: "post",
            //     url: baseUrl + '/merchant/kyc-update',
            //     data: formData,
            //     headers: { "token": localStorage.getItem('userToke') }
            // })
            commonApi.post('merchant/kyc-update', formData)
                .then((res) => {
                    setIsLoading(false);
                    setOpenAlert(true);
                    scrollToTop();
                    if (res?.data?.s === 0) {
                        setAlertMessage(res?.data?.msg);
                        setSeverity('error');
                    } else {
                        setAlertMessage(res?.data?.msg);
                        setSeverity('success');
                    }
                }).catch((err) => {
                    setOpenAlert(true);
                    setAlertMessage(err?.response?.data?.msg);
                    setSeverity('error')
                    setIsLoading(false);
                });
        }
    };
    return (
        <Box className="common-form-container">
            <form className="common-form-data" onSubmit={handleSubmit}>
                <Card className="form-section">
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <TextField
                                    label="Aadhar Card No."
                                    name="adhar_card_no"
                                    defaultValue={formDataTemp?.adhar_card_no}
                                    onChange={handleChange}
                                    fullWidth
                                    // margin="normal"
                                    size='small'
                                    error={!!formErrors.adhar_card_no}
                                    helperText={formErrors.adhar_card_no}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <Input
                                    type="file"
                                    id="aadharInput"
                                    style={{ display: 'none' }}
                                    name='adhar_card_file'
                                    onChange={handleChange}
                                    inputProps={{ accept: 'image/jpeg, image/png, .pdf' }}
                                    error={!!formErrors.adhar_card_file}
                                // helperText={formErrors.adhar_card_file}
                                />
                                <FormControl component="fieldset" sx={{ width: '100%' }}>
                                    <label htmlFor="aadharInput" style={{ textAlign: 'center' }}>
                                        <Button
                                            variant="outlined"
                                            component="span"
                                            startIcon={<CloudUploadIcon />}
                                            className="upload-button"
                                        >
                                            Upload Aadhar Copy
                                        </Button>
                                        <IconButton
                                            color="primary"
                                            component="span"
                                            disabled={!formDataTemp.adhar_card_file}
                                        >
                                            <CloudUploadIcon />
                                        </IconButton>
                                        {/* {formDataTemp?.adhar_card_file && (
                                            <div>
                                                Selected File: {formDataTemp.adhar_card_file.name ?? formDataTemp.adhar_card_file ?? ''}
                                            </div>
                                        )} */}
                                        {formDataTemp?.adhar_card_file && (
                                            <div>
                                                {formDataTemp?.adhar_card_file.type?.startsWith('image/') ? (
                                                    <img
                                                        src={URL.createObjectURL(formDataTemp?.adhar_card_file)}
                                                        alt="Selected"
                                                        style={{ maxWidth: '100%', width: '100px' }}
                                                    />
                                                ) : (
                                                    <a href={`${AppUrl}/download/${formDataTemp?.adhar_card_file}?pathName=merchants`}>
                                                        <img
                                                            src={`${AppUrl}/download/${formDataTemp?.adhar_card_file}?pathName=merchants`}
                                                            alt="Selected"
                                                            style={{ maxWidth: '100%', width: '100px' }}
                                                        />
                                                    </a>
                                                )}
                                            </div>
                                        )}
                                    </label>
                                    {formErrors?.adhar_card_file && <Typography sx={{ margin: 0, fontSize: '12px', color: '#d32f2f' }}> {formErrors.adhar_card_file} </Typography>}
                                </FormControl>
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <TextField
                                    label="PAN Number"
                                    name="pan_card_no"
                                    defaultValue={formDataTemp?.pan_card_no}
                                    onChange={handleChange}
                                    fullWidth
                                    // margin="normal"
                                    size='small'
                                    error={!!formErrors.pan_card_no}
                                    helperText={formErrors.pan_card_no}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <Input
                                    type="file"
                                    id="panInput"
                                    style={{ display: 'none' }}
                                    name='pan_card'
                                    onChange={handleChange}
                                    inputProps={{ accept: 'image/jpeg, image/png, .pdf' }}
                                    error={!!formErrors.pan_card}
                                // helperText={formErrors.pan_card}
                                />
                                <FormControl component="fieldset" sx={{ width: '100%' }}>
                                    <label htmlFor="panInput" style={{ textAlign: 'center' }}>
                                        <Button
                                            variant="outlined"
                                            component="span"
                                            startIcon={<CloudUploadIcon />}
                                            className="upload-button"
                                        >
                                            Upload Pan Copy
                                        </Button>
                                        <IconButton
                                            color="primary"
                                            component="span"
                                            disabled={!formDataTemp.pan_card}
                                        >
                                            <CloudUploadIcon />
                                        </IconButton>
                                        {/* {formDataTemp?.pan_card && (
                                            <div>
                                                Selected File: {formDataTemp.pan_card.name ?? formDataTemp.pan_card ?? ''}
                                            </div>
                                        )} */}
                                        {formDataTemp?.pan_card && (
                                            <div>
                                                {formDataTemp?.pan_card.type?.startsWith('image/') ? (
                                                    <img
                                                        src={URL.createObjectURL(formDataTemp?.pan_card)}
                                                        alt="Selected"
                                                        style={{ maxWidth: '100%', width: '100px' }}
                                                    />
                                                ) : (
                                                    <a href={`${AppUrl}/download/${formDataTemp?.pan_card}?pathName=merchants`}>
                                                        <img
                                                            src={`${AppUrl}/download/${formDataTemp?.pan_card}?pathName=merchants`}
                                                            alt="Selected"
                                                            style={{ maxWidth: '100%', width: '100px' }}
                                                        />
                                                    </a>
                                                )}
                                            </div>
                                        )}
                                    </label>
                                    {formErrors?.pan_card && <Typography sx={{ margin: 0, fontSize: '12px', color: '#d32f2f' }}> {formErrors.pan_card} </Typography>}
                                </FormControl>
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <TextField
                                    label="GST Number"
                                    name="gst_number"
                                    defaultValue={formDataTemp?.gst_number}
                                    onChange={handleChange}
                                    fullWidth
                                    // margin="normal"
                                    size='small'
                                    error={!!formErrors.gst_number}
                                    helperText={formErrors.gst_number}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <Input
                                    type="file"
                                    id="gstInput"
                                    style={{ display: 'none' }}
                                    name='gst_file'
                                    onChange={handleChange}
                                    inputProps={{ accept: 'image/jpeg, image/png, .pdf' }}
                                    error={!!formErrors.gst_file}
                                // helperText={formErrors.gst_file}
                                />
                                <FormControl component="fieldset" sx={{ width: '100%' }}>
                                    <label htmlFor="gstInput" style={{ textAlign: 'center' }}>
                                        <Button
                                            variant="outlined"
                                            component="span"
                                            startIcon={<CloudUploadIcon />}
                                            className="upload-button"
                                        >
                                            Upload GST Copy
                                        </Button>
                                        <IconButton
                                            color="primary"
                                            component="span"
                                            disabled={!formDataTemp.gst_file}
                                        >
                                            <CloudUploadIcon />
                                        </IconButton>
                                        {/* {formDataTemp?.gst_file && (
                                            <div>
                                                Selected gst_file: {formDataTemp.gst_file.name ?? formDataTemp.gst_file ?? ''}
                                            </div>
                                        )} */}
                                        {formDataTemp?.gst_file && (
                                            <div>
                                                {formDataTemp?.gst_file.type?.startsWith('image/') ? (
                                                    <img
                                                        src={URL.createObjectURL(formDataTemp?.gst_file)}
                                                        alt="Selected"
                                                        style={{ maxWidth: '100%', width: '100px' }}
                                                    />
                                                ) : (
                                                    <a href={`${AppUrl}/download/${formDataTemp?.gst_file}?pathName=merchants`}>
                                                        <img
                                                            src={`${AppUrl}/download/${formDataTemp?.gst_file}?pathName=merchants`}
                                                            alt="Selected"
                                                            style={{ maxWidth: '100%', width: '100px' }}
                                                        />
                                                    </a>
                                                )}
                                            </div>
                                        )}
                                    </label>
                                    {formErrors?.gst_file && <Typography sx={{ margin: 0, fontSize: '12px', color: '#d32f2f' }}> {formErrors.gst_file} </Typography>}
                                </FormControl>
                            </Grid>
                            {/* </Grid> */}
                            <Grid item size={{ xs: 12, md: 12 }} sx={{ textAlign: 'right', marginTop: '1rem' }}>
                                <Button variant="contained" color="primary" type="submit">
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </form>
        </Box>
    );
};

export default KycDetails;
